import { render, staticRenderFns } from "./emailResumeDetail.vue?vue&type=template&id=2e4897ec&scoped=true"
import script from "./emailResumeDetail.vue?vue&type=script&lang=js"
export * from "./emailResumeDetail.vue?vue&type=script&lang=js"
import style0 from "./emailResumeDetail.vue?vue&type=style&index=0&id=2e4897ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4897ec",
  null
  
)

export default component.exports